import { render } from "./QuickMatrixCard4.vue?vue&type=template&id=6510062c&scoped=true"
import script from "./QuickMatrixCard4.vue?vue&type=script&lang=js"
export * from "./QuickMatrixCard4.vue?vue&type=script&lang=js"

import "./QuickMatrixCard4.vue?vue&type=style&index=0&id=6510062c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6510062c"]])

export default __exports__